import { FC } from "react";
import { MainTemplate } from "templates/MainTemplate";
import { PayTemplate } from "./PayTemplate";

export interface PayPageProps {
  className?: string;
}

const PayPage: FC<PayPageProps> = ({ className = "" }) => {
  return (
    <MainTemplate>
      <PayTemplate />
    </MainTemplate>
  );
};

export default PayPage;
